import { rootCanonicalUrl } from "@/config/canonical";
import { useSeoCopy } from "@/config/seo";
import { HeroSection } from "@/containers/HeroSection";
import { BREAKPOINTS } from "@/settings";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { setShowFooter } from "../../redux/globalState/globalStateSlice";
import { AppDispatch } from "../../redux/store";
import { getUserSelector } from "../../redux/user/userSlice";
import { DefaultSquadBuilder } from "./Default/DefaultSquadBuilder";

const SquadBuilder = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector(getUserSelector);
  const desktopMode = !useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  const tabletOrLargerMode = !useMediaQuery(BREAKPOINTS.MOBILE.query);
  const seo = useSeoCopy("squadBuilder");

  // No footer on the builder: on desktop its fixed side panels would cover it.
  useEffect(() => {
    dispatch(setShowFooter(false));
    return () => {
      dispatch(setShowFooter(true));
    };
  }, [dispatch]);

  return (
    <>
      <HeroSection
        helmetTitle={seo.title}
        helmetDescription={seo.description}
        helmetCanonicalLink={rootCanonicalUrl("/squad-builder")}
        shouldBeInTheDocumentFlow={true}
      />
      <DefaultSquadBuilder
        user={user}
        desktopMode={desktopMode}
        tabletOrLargerMode={tabletOrLargerMode}
      />
    </>
  );
};

export default SquadBuilder;
